import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import ImpersonationBanner from './components/ImpersonationBanner';
import { installSessionSync } from './service/impersonation';

installSessionSync();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <HashRouter>
            <Provider store={store}>
                <AppWrapper></AppWrapper>
                <ImpersonationBanner />
            </Provider>
        </HashRouter>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
